import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, Clock3, History, RefreshCw } from "lucide-react";
import { api } from "../api";
import { Header } from "./Shell";
import "./SystemReleases.css";

const formatDate = value => {
  if (!value) return "Data non disponibile";

  const parts = value.split("-");
  if (parts.length !== 3) return value;

  return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

export function SystemReleases() {
  const [releases, setReleases] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await api.get("/system-releases");
      const items = Array.isArray(response.data) ? response.data : [];

      setReleases(items);
      setExpanded(items.length ? [items[0].id] : []);
    } catch {
      setError("Impossibile caricare la cronologia degli aggiornamenti.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const toggle = id => {
    setExpanded(previous =>
      previous.includes(id)
        ? previous.filter(item => item !== id)
        : [...previous, id]
    );
  };

  return (
    <>
      <Header
        kicker="118FINDER / EVOLUZIONE DEL SISTEMA"
        title="Novità e aggiornamenti"
        subtitle="Consulta la cronologia delle versioni e scopri le funzionalità introdotte."
        showStatus={false}
      />

      <section className="system-releases-intro">
        <div className="system-releases-intro-icon">
          <History size={28} />
        </div>
        <div>
          <span className="eyebrow">CRONOLOGIA DELLA PIATTAFORMA</span>
          <h2>L'evoluzione di 118Finder</h2>
          <p>
            Tutti gli aggiornamenti pubblicati, dalla versione più recente
            alle precedenti.
          </p>
        </div>
      </section>

      {loading && (
        <div className="system-releases-message">
          Caricamento degli aggiornamenti...
        </div>
      )}

      {!loading && error && (
        <div className="system-releases-message system-releases-error">
          <p>{error}</p>
          <button type="button" className="row-btn" onClick={load}>
            <RefreshCw size={14} />
            Riprova
          </button>
        </div>
      )}

      {!loading && !error && releases.length === 0 && (
        <div className="system-releases-message">
          Nessuna versione pubblicata al momento.
        </div>
      )}

      {!loading && !error && releases.length > 0 && (
        <div className="system-releases-timeline">
          {releases.map((release, index) => {
            const isOpen = expanded.includes(release.id);

            return (
              <article
                className="system-release-entry"
                key={release.id}
              >
                <div className="system-release-marker">
                  <span className={index === 0 ? "latest" : ""} />
                </div>

                <div className="system-release-card">
                  <button
                    type="button"
                    className="system-release-heading"
                    onClick={() => toggle(release.id)}
                    aria-expanded={isOpen}
                  >
                    <div className="system-release-heading-main">
                      <div className="system-release-heading-top">
                        <span className="system-release-version">
                          Versione {release.version}
                        </span>

                        {index === 0 && (
                          <span className="system-release-latest">
                            ULTIMA VERSIONE
                          </span>
                        )}
                      </div>

                      <h3>{release.title}</h3>

                      <span className="system-release-date">
                        <Clock3 size={13} />
                        {formatDate(release.release_date)}
                      </span>
                    </div>

                    {isOpen
                      ? <ChevronUp size={20} />
                      : <ChevronDown size={20} />}
                  </button>

                  {isOpen && (
                    <div className="system-release-content">
                      {release.description && (
                        <p className="system-release-description">
                          {release.description}
                        </p>
                      )}

                      {Array.isArray(release.changes) &&
                        release.changes.length > 0 && (
                          <div className="system-release-changes">
                            <h4>Novità introdotte</h4>
                            <ul>
                              {release.changes.map((change, changeIndex) => (
                                <li key={changeIndex}>{change}</li>
                              ))}
                            </ul>
                          </div>
                        )}

                      {!release.description &&
                        (!release.changes || release.changes.length === 0) && (
                          <p className="system-release-description">
                            Nessun dettaglio aggiuntivo disponibile.
                          </p>
                        )}
                    </div>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      )}
    </>
  );
}
